/**
 * @name validatePlatformObj
 * @description The function is used to check the validity of Ap Tag platform obj from tgmr doc for BVS, it has several conditions which are to be fulfilled to update section Id for BVS
 * 1. check Ap Tag platform obj
 * 2. check if Ap Tag platform obj not archieved
 * 3. check Ap Tag platform specific section Id
 */
export const validatePlatformObj = (
	platformAdObj,
	platform,
	sectionId,
	apTagType,
	sectionIdLabel
) => {
	console.log(platformAdObj, platform, sectionId, apTagType, sectionIdLabel);
	// 1. check Ap Tag platform obj must be present in tgmr doc
	if (!platformAdObj || Object.keys(platformAdObj).length === 0) {
		throw new Error(
			` Please create an ApTag for ${apTagType} from console, it is missing in ${platform} platform.`
		);
	}
	// 2. check if Ap Tag platform obj not archived otherwise we can't switch section Id or enable sectionId if the Ap Tag is archived
	if (!platformAdObj?.isActive) {
		throw new Error(
			`The ${apTagType} ApTag is archived in ${platform} platform, please first unArchived the ApTag to change section Id.`
		);
	}
	// 3. check if Ap Tag platform specific section Id must be present in rawConfig
	if (!sectionId) {
		throw new Error(
			`Please create an ApTag for ${apTagType}, ${sectionIdLabel} is missing in ${platform} platform.`
		);
	}
};
